import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';

export const FormErrorText = (props: TextProps) => {
  return <Text color={'red'} fontSize="sm" {...props} />;
};
